import Vue from 'vue'
import axios from 'axios'
import {assertString} from '../../utils'
import {backendUri} from '../common'
import {Roles} from '../../enums'

const ax = axios.create({
  baseURL: `${backendUri}/user`,
  headers: { 'Let-Me-In': 'PathView' },
  timeout: 15000
})

const AUTH_TOKEN = 'auth-token'
const DEFAULT_RATES_TABLE_COLUMNS = [1, 2, 3, 4, 8]
const DEFAULT_ORDERS_TABLE_COLUMNS = {
  client: [0, 1, 2, 3, 4],
  agent: [0, 1, 2, 3, 4]
}
const DEFAULT_FLIGHTS_TABLE_COLUMNS = [1, 2, 3, 4]

export default {
  namespaced: true,
  state: {
    token: (function () {
      const tkn = localStorage.getItem(AUTH_TOKEN) || null
      if (tkn) {
        ax.defaults.headers.common['Authorization'] = `Bearer ${tkn}`
      }
      return tkn
    }()),
    user: null,
    ratesTableColumns: DEFAULT_RATES_TABLE_COLUMNS,
    ordersTableColumns: DEFAULT_ORDERS_TABLE_COLUMNS,
    flightsTableColumns: DEFAULT_FLIGHTS_TABLE_COLUMNS
  },
  getters: {
    isAuthenticated: state => {
      return (state && !!state.token) || false
    },
    isUser: state => {
      return state.user ? !!state.user.roles.filter(r => r === Roles.USER || r === Roles.ADMIN).length : false
    },
    isManager: state => {
      return state.user ? !!state.user.roles.filter(r => r === Roles.MANAGER || r === Roles.ADMIN).length : false
    },
    isAdmin: state => {
      return state.user ? (state.user.roles).includes(Roles.ADMIN) : false
    }
    // authStatus: state => state.status
  },
  mutations: {
    SET_RATES_TABLE_COLUMNS: (state, columns) => {
      Vue.set(state, 'ratesTableColumns', columns)
    },
    SET_ORDERS_TABLE_COLUMNS: (state, {columns, type}) => {
      Vue.set(state.ordersTableColumns, type, columns)
    },
    SET_FLIGHTS_TABLE_COLUMNS: (state, columns) => {
      Vue.set(state, 'flightsTableColumns', columns)
    },
    AUTH_SUCCESS: (state, token) => {
      state.token = token
    },
    AUTH_CLEAR: state => {
      state.token = null
      state.user = null
      state.ratesTableColumns = DEFAULT_RATES_TABLE_COLUMNS
    },
    SET_PROFILE: (state, user) => {
      state.user = user
      if (user && user.ratesTableColumns) {
        Vue.set(state, 'ratesTableColumns', user.ratesTableColumns)
      }
      if (user && user.ordersTableColumns) {
        Vue.set(state, 'ordersTableColumns', user.ordersTableColumns)
      }
      if (user && user.flightsTableColumns) {
        Vue.set(state, 'flightsTableColumns', user.flightsTableColumns)
      }
    }
  },
  actions: {
    checkRole: ({state}, role) => {
      return state.user ? state.user.roles.includes(role) : false
    },
    registerRequest: ({commit, dispatch}, params) => {
      assertString(params.name)
      assertString(params.password)

      return ax.post('/register', params)
    },
    authRequest: ({commit, dispatch}, params) => {
      assertString(params.name)
      assertString(params.password)

      return ax.post('/login', params)
        .then(response => {
          const token = response.data
          localStorage.setItem(AUTH_TOKEN, token)
          ax.defaults.headers.common['Authorization'] = `Bearer ${token}`
          return dispatch('fetchProfile')
            .then(() => {
              commit('AUTH_SUCCESS', token)
            })
            .catch(() => {
              ax.defaults.headers.common['Authorization'] = null
            })
        })
    },
    authLogout: ({commit}) => {
      ax.defaults.headers.common['Authorization'] = null
      localStorage.removeItem(AUTH_TOKEN)
      commit('AUTH_CLEAR')
    },
    setRatesTableColumns: ({commit, getters, dispatch}, columns) => {
      commit('SET_RATES_TABLE_COLUMNS', columns)
      if (getters.isAuthenticated) {
        return dispatch('apiProfileSetRatesTableColumns', columns, {root: true})
      }
    },
    setOrdersTableColumns: ({commit, getters, dispatch}, {type, columns}) => {
      commit('SET_ORDERS_TABLE_COLUMNS', {type, columns})
      if (getters.isAuthenticated) {
        return dispatch('apiProfileSetOrdersTableColumns', {columns, type}, {root: true})
      }
    },
    setFlightsTableColumns: ({commit, getters, dispatch}, columns) => {
      commit('SET_FLIGHTS_TABLE_COLUMNS', columns)
      if (getters.isAuthenticated) {
        return dispatch('apiProfileSetFlightsTableColumns', columns, {root: true})
      }
    },
    fetchProfile: ({commit, dispatch}) => {
      return dispatch('apiGetProfile', null, {root: true})
        .then(profile => { commit('SET_PROFILE', profile) })
        .catch(() => { commit('AUTH_CLEAR') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js